import { useCallback, useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

import SmoothScroll from "@/components/site/SmoothScroll";
import Loader from "@/components/site/Loader";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyMe from "@/components/site/WhyMe";
import Process from "@/components/site/Process";
import Results from "@/components/site/Results";
import Reels from "@/components/site/Reels";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import FloatingCTA from "@/components/site/FloatingCTA";

import BlogIndex from "@/components/site/BlogIndex";
import BlogPost from "@/components/site/BlogPost";
import AskRitesh from "@/components/site/AskRitesh";
import QuestionsPage from "@/components/site/QuestionsPage";
import AdminQuestion from "@/components/site/AdminQuestion";

function Landing() {
  const [initialService, setInitialService] = useState("general");

  const openForm = useCallback((service = "general") => {
    setInitialService(service);
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  // Handle #hash on landing (e.g. arriving via /#contact from a blog post)
  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    // Wait one frame so sections mount before scrolling
    requestAnimationFrame(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, []);

  return (
    <>
      {/* SEO H1 — the visual headline lives inside <Hero /> as a big design element.
          Google needs the person + brand as an H1 to rank for the founder's name. */}
      <h1 className="sr-only">
        Ritesh Sikri — India's Leading Nightlife Consultant &amp; Founder of Rubiemaze Inc
      </h1>
      <Hero onOpenForm={openForm} />
      <Marquee />
      <About />
      <Services onOpenForm={openForm} />
      <WhyMe />
      <Process />
      <Results />
      <Reels />
      <Testimonials />
      <FAQ />
      <AskRitesh />
      <FinalCTA initialService={initialService} />
    </>
  );
}

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const isLanding = location.pathname === "/";

  return (
    <div className="App relative">
      <div className="noise-overlay" aria-hidden />
      <Loader />
      <SmoothScroll />
      <Nav isLanding={isLanding} onNav={navigate} />

      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/questions" element={<QuestionsPage />} />
          <Route path="/admin/q/:token" element={<AdminQuestion />} />
        </Routes>
      </main>

      <Footer />
      <FloatingCTA />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
